module.exports = "\n\n  <router-view></router-view>\n\n<!-- </div> -->"